import React, { useEffect } from "react";
import Header from "../../../Layouts/Components/Header";
import { MatchingFilter } from "./MatchingFilter";
import MatchingDayList from "./MatchingDayList";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import useSnackBar from "../../Hooks/useSnackBar";
import * as yup from "yup";
import { endOfDay, startOfDay } from "date-fns";
import format from "date-fns/format";
const MatchingDay = () => {
  const startDate = startOfDay(new Date());
  const endDate = endOfDay(new Date());
  const { error, snackbar, success } = useSnackBar();
  const dispatch = useDispatch();

  const validationSchema = yup.object().shape({
    dateFrom: yup.string().nullable().required("Start Date is required"),
    dateTo: yup.string().nullable().required("End Date is required"),
    RuleName: yup.array().min(1).required().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      dateFrom: startDate || null,
      dateTo: endDate || null,
      RuleName: [],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const mainValues = {
        from: format(new Date(values.dateFrom), "yyyy-MM-dd HH:mm"),
        to: format(new Date(values.dateTo), "yyyy-MM-dd HH:mm"),
      };
      console.log(mainValues);
      // dispatch(getFollowingAlerts(
      //   {
      //   pageNumber:1,
      //   pageSize:10,
      //   searchCriteria:{
      //     ...mainValues
      //   }
      // },
      // error
      // ))
    },
  });

  const data = {
    from: formik.values.dateFrom,
    to: formik.values.dateTo,
  };
  useEffect(() => {
    console.log("formik.values");

    //  dispatch(getFollowingAlerts(
    //   {
    //   pageNumber:1,
    //   pageSize:10,
    //   searchCriteria:{
    //     from:format(formik?.values?.dateFrom || startDate, "yyyy-MM-dd HH:mm"),
    //     to:format(formik?.values?.dateTo || endDate, "yyyy-MM-dd HH:mm"),
    //   }
    //  },
    //  error

    //  ))

    return () => {
      // dispatch(resetFollowingAlerts())
    };
  }, [error]);

  return (
    <>
      {snackbar}
      <Header headLine="Matching Day" />
      <MatchingFilter formik={formik} />
      <MatchingDayList data={data} error={error} success={success} />
    </>
  );
};

export default MatchingDay;
